import React from 'react';
import dynamic from 'next/dynamic';
import { isInternetExplorer } from 'app/lib/utils';
import UnsupportedBrowser from 'app/components/UnsupportedBrowser/UnsupportedBrowser';
import { RouterWithOptimizely } from './Router/Router';

function App() {
  return isInternetExplorer() ? <UnsupportedBrowser /> : <RouterWithOptimizely />;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const DynamicComponentWithNoSSR = dynamic(() => Promise.resolve(App), {
  ssr: false,
});

// define component name property
Object.defineProperty(DynamicComponentWithNoSSR, 'name', {
  writable: true,
  value: 'DynamicComponentWithNoSSR',
});

export default DynamicComponentWithNoSSR;
